import { useSelector } from 'react-redux'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'
import { HeaderUserMenu, } from '../../../partials'
import { selectCurrentUser } from '../../../../app/modules/auth/features/auth.slice'
import useNetwork from '../../../../app/hooks/useNetwork'


const AsideToolbar = () => {
  const currentUser = useSelector(selectCurrentUser);
  const { online, } = useNetwork()
  return (
    <>
      {/*begin::User*/}
      <div className='aside-user d-flex align-items-sm-center justify-content-center py-5' style={{ border: 'none' }}>
        {/*begin::Symbol*/}
        <div className='symbol symbol-50px'>
          <img src={currentUser?.profile_image || toAbsoluteUrl('media/avatars/blank.png')} alt='profile photo' />
        </div>
        {/*end::Symbol*/}

        {/*begin::Wrapper*/}
        <div className='aside-user-info flex-row-fluid flex-wrap ms-5'>
          {/*begin::Section*/}
          <div className='d-flex'>
            {/*begin::Info*/}
            <div className='flex-grow-1 me-2'>
              {/*begin::Username*/}
              <a href='#' className='text-hover-primary fs-6 fw-bold'>
                {currentUser?.user_name}
              </a>
              {/*end::Username*/}

              {/*begin::Description*/}
              <span className='text-gray-600 fw-bold d-block fs-8 mb-1'>{currentUser?.role?.role}</span>
              {/*end::Description*/}

              {/*begin::Label*/}
              <div className={`d-flex align-items-center fw-bolder text-${online ? 'success' : 'danger'} fs-9`}>
                <span className={`bullet bullet-dot bg-${online ? 'success' : 'danger'} me-1`}></span>{online ? 'Online' : 'Offline'}
              </div>
              {/*end::Label*/}
            </div>
            {/*end::Info*/}

            {/*begin::User menu*/}
            <div className='me-n2'>
              {/*begin::Action*/}
              <a
                href='#'
                className='btn btn-icon btn-sm btn-active-color-primary mt-n2'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-start'
                data-kt-menu-overflow='false'
              >
                <KTIcon iconName='setting-2' className='text-muted fs-1' />
              </a>

              <HeaderUserMenu />
              {/*end::Action*/}
            </div>
            {/*end::User menu*/}
          </div>
          {/*end::Section*/}
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::User*/}

      {/*begin::Aside search*/}
      {/* <div className='aside-search py-5'> */}
      {/* <?php Theme::getView('partials/search/_inline', array(
        'class' => 'w-100',
        'menu-placement' => 'bottom-start',
        'responsive' => 'false'
    ))?> */}
      {/* <Search /> */}
      {/* </div> */}
      {/*end::Aside search*/}
    </>
  )
}

export { AsideToolbar }
